module.exports = __webpack_public_path__ + "assets/img/de039d4dc37fc11c7e798857dae0b358.svg";